import React from 'react';
import { Animation } from '../Animation';
import { Overlay } from './Backdrop.style';

interface BackdropProps {
  children: React.ReactNode;
}

const Backdrop = ({ children, ...props }: BackdropProps): JSX.Element => (
  <Animation
    key="backdrop"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.4 }}
  >
    <Overlay data-testid="drawer-backdrop" {...props}>
      {children}
    </Overlay>
  </Animation>
);

export { Backdrop };
